import { FieldBlock, InputBlock } from '@coast/schemas';
import { useCallback, useContext } from 'react';
import { MBClearButton } from '@shared/components/MBButton';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { CardThemeContext } from '@shared/components/blocks/contexts/theme';
import { MBBlockLabel } from '@shared/components/blocks/utils/label';
import { MBIconV2 } from '@shared/components/image';
import { ColorThemeContext } from '@shared/styles';
import { useLayoutConfig } from '../../contexts/layoutConfig';

export interface FormInputProps {
  block: InputBlock;
}

export function BlockIcon({ name, icon }: { name?: string; icon: FieldBlock['icon'] }) {
  const colors = useContext(ColorThemeContext);
  const cardTheme = useContext(CardThemeContext);
  const { errors } = useCardFormContext();
  const {
    blockIcon: { size },
  } = useLayoutConfig();
  const error = name ? errors[name] : undefined;
  return (
    <MBIconV2
      color={(() => {
        if (!!error) {
          return colors.error.foreground;
        }
        if (cardTheme === 'stale') {
          return colors.foregroundInactive;
        }
        return colors.accent;
      })()}
      name={icon}
      size={size}
    />
  );
}

export function InputLabel({ block }: FormInputProps) {
  const { values } = useCardFormContext();
  const value = values[block.name];
  if (!block.label) {
    return null;
  }
  if (value === undefined || value === null || value === '') {
    return null;
  }
  return <MBBlockLabel label={block.label} />;
}

export function ClearButton({ block, onClear }: FormInputProps & { onClear?: () => void }) {
  const { values, setFieldValue } = useCardFormContext();
  const value = values[block.name];
  const onChange = useCallback(() => {
    setFieldValue(block.name, null);
    onClear?.();
  }, [block.name, setFieldValue, onClear]);
  if (value) {
    return <MBClearButton onPress={onChange} />;
  }
  return null;
}

export function InputError({ block }: FormInputProps) {
  const { errors } = useCardFormContext();
  const error = errors[block.name];
  if (Boolean(error)) {
    return (
      <View paddingTop={0} padding={2}>
        <Text size="body2" danger>
          {error}
        </Text>
      </View>
    );
  }
  return null;
}
